module.exports = __webpack_public_path__ + "img/sprinkle-10.d65e339d.jpg";